import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202605",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 11204,
  clicks: 171,
  adsSpendDollars: 918,
  budgetDollars: 15000,
  salesDollars: 4679,
  bestEstimateRoas: 5.1,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.06,
  newCustomersAcquired: 4,
  reorderConversions: 8,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
